export default {
  addStatusTags: 'Add status tags',
  addEvent: 'Add event',
  addFieldToGrid: 'Add field to grid',
  columnProperties: 'Column properties',
  columnType: 'Column type',
  columnName: 'Column name',
  customTab: 'Custom tab',
  teamCustomTags: 'Team custom tags',
  enterColumnName: 'Enter column name',
  enterOption: 'Enter option',
  addAnOption: 'Add an option',
  canViewAndEdit: 'Can view and edit',
  canView: 'Can view',
  canEdit: 'Can edit',
  logChanges: 'Log changes',
  logChangesDescription:
    'Create a record in the company profile for each value change',
  onlyMe: 'Only me',
  myTeam: 'My team',
  allWorkers: 'All workers',
  fieldKey: 'Field key',
  addPerformer: 'Add performer',
  addUser: 'Add user',
  addTerms: 'Add terms...',
  addYourTeamMembersToCompany: 'Add your team members to company',
  accountReceivables: 'Account receivables',
  agreement: 'Agreement',
  artistsTeam: 'Artists team',
  airTable: 'Airtable',
  automaticDebtRepayment: 'Automatic debt repayment',
  automaticPaymentSC: 'Automatic payment SC',
  automaticContractorPayment: 'Automatic contractor payment',
  autoCheckIn: 'Auto check-in',
  autoCheckInRule: 'Auto check-in rule',
  autoCheckInRules: 'Auto check-in rules',
  author: 'Author',
  basicInfo: 'Basic info',
  blockAccount: 'Block account',
  blockedCompanies: 'Blocked companies',
  defaultView: 'DefaultView',
  availableColumns: 'Available columns',
  availableColumnsDescription:
    'Select the columns you want to include in this view.',
  dragToReorder: 'Drag to reorder.',
  filterColumns: 'Filter columns...',
  newView: 'New view',
  predefinedFilters: 'Pre-defined filters',
  selectedColumns: 'Selected columns',
  viewName: 'View name',
  changeEmail: 'Change email',
  changeCompanyOwner: 'Change company owner',
  changeCM: 'Change CM',
  removeAllCMs: 'Remove all CMs',
  createCompany: 'Create company',
  created: 'Created',
  createAndViewCompany: 'Create and view company',
  debtLimit: 'Debt limit',
  deferredPayment: 'Deferred payment (days)',
  defaultTaskState: 'Default task state',
  description: 'Description',
  deliveryTime: 'Delivery time (days)',
  deleteTemplate: 'Delete template',
  downloadAllItems: 'Download All Items',
  enterTheEmailAddressOfTheUser:
    'Enter the email address of the user you want to share your tasks and projects with',
  eventDispatcher: 'Event dispatcher',
  eventName: 'Event name',
  favorite: 'Favorite companies',
  financeInfo: 'Finance info',
  files: 'Files',
  followers: 'Followers',
  finLastPayments: 'Fin last payment',
  finStatus: 'Fin status',
  select: 'Select teams',
  payoutStatus: 'Payout status',
  paymentsStatus: 'Payments status',
  paymentsStatusTags: 'Payments status tags',
  performer: 'Performer',
  performers: 'Performers',
  performersTat: 'Performers TAT',
  performersTeam: 'Performers team',
  plural: 'Teams',
  pluralLowerCase: 'teams',
  singular: 'Team',
  add: 'Add team',
  'add...': 'Add teams...',
  change: 'Change teams',
  change_creator: 'Change team creator',
  create: 'Create team',
  creator: 'Team creator',
  create_and_view: 'Create and view team',
  dashboard: 'Dashboard',
  select_with_dots: 'Select teams...',
  selected: 'Selected teams',
  no: 'No teams',
  of: 'Team of',
  type: 'Team type',
  select_type: 'Select team type',
  view: 'View team',
  members: 'Team members',
  selectUser: 'Select user',
  users: 'Team users',
  profile: 'Profile',
  provideAccess: 'Provide access',
  provisionForBadDebt: 'Provision for bad debt (%)',
  provisionForRevision: 'Provision for revision (%)',
  permissions: 'Permissions',
  personalization: 'Personalization',
  plannedDate: 'Planned date',
  recalculateBalances: 'Recalculate balances',
  records: 'Records',
  reports: 'Reports',
  requirements: 'Requirements',
  resume: 'Resume',
  restoreEvent: 'Restore event',
  marketingData: 'Marketing data',
  mql: 'MQL',
  sql: 'SQL',
  hourlyRate: 'Hourly rate ($/h)',
  holdRate: 'Hold rate',
  bookId: 'Book id',
  info: 'Info',
  inviteNewUser: 'Invite new user',
  integrations: 'Integrations',
  delete: 'Delete Team',
  deleted: 'Team Deleted',
  allCompanies: 'All companies',
  allPerformers: 'All performers',
  api: 'API',
  companies: 'Companies',
  companiesLowerCase: 'companies',
  selectedCompaniesLowerCase: 'selected companies',
  corevsharers: 'Corevsharers',
  clients: 'Clients',
  clientTeam: 'Client team',
  name: 'Name',
  noCompanies: 'No companies',
  ownerId: 'Owner id',
  coefficient: 'Coefficient',
  companyMembers: 'Company members',
  companyName: 'Company name',
  companyHasNoOwner: 'Company has no owner',
  companyLibrary: 'Company library',
  companyUsers: 'Company users',
  changeStatus: 'Change status',
  changeMql: 'Change MQL',
  changeSql: 'Change SQL',
  changeSubcategory: 'Change subcategory',
  batchChange: 'Batch change',
  batchFieldUpdate: 'Batch field update',
  editCompanyPicture: 'Edit company picture',
  goToProfile: 'Go to profile',
  handler: 'Handler',
  lastPayments: 'Last payment',
  lastActivity: 'Last activity',
  lastUpdate: 'Last Update',
  leadCreationDate: 'Lead creation date',
  firstPaymentDate: 'First payment date',
  list: 'List',
  leaders: 'Leaders',
  londonDynamicsApi: 'London Dynamics API',
  cm: 'CM',
  pm: 'PM',
  recentCompanies: 'Recent companies',
  respondTime: 'Respond time',
  revenueShare: 'Revenue share',
  revisions: 'Revisions',
  selectCompany: 'Select company',
  selectCompanies: 'Select companies...',
  selectCompanyWithoutEllipsis: 'Select company',
  selectEvent: 'Select event',
  status: 'Status',
  statusTag: 'Status tag',
  statusPlural: 'Statuses',
  searchCompanies: 'Search companies',
  searchPerformers: 'Search performers',
  settings: 'Settings',
  sendInvitations: 'Send invitations',
  shares: 'Shares',
  smartContractSettings: 'Smart contract settings',
  finance: {
    amr: 'AMR',
    balance: 'Balance',
    debt: 'Debt',
    revenue: 'Revenue',
    sigmaPayments: 'Σ Payments',
    averagePaymentGap: 'Average payment gap',
    currentPaymentGap: 'Current payment gap',
    deferredPaymentDays: 'Deferred payment (days)'
  },
  statuses: {
    new: 'New',
    active: 'Active',
    paused: 'Paused',
    declined: 'Declined',
    realDecline: 'Real decline',
    noPayments: 'No payments',
    pbd: 'PBD',
    churn: 'Churn',
    reconnect: 'Reconnect'
  },
  source: 'Source',
  subbooks: 'Subbooks',
  suspendEvent: 'Suspend event',
  scTemplates: 'SC templates',
  tasksWithoutSourceFiles: 'Tasks without source files',
  tat: 'TAT',
  terms: 'Terms',
  transactionFee: 'Transaction fee (%)',
  trigger: 'Trigger',
  totalPayments: 'Total payments',
  thisMonthPayments: 'This month payments',
  viewPerTask: 'Views per task',
  vendorForm: 'Vendor form',
  walmartMyLibraryFilters: 'Walmart my library filters',
  billingInfo: 'Billing info',
  items: 'Items',
  wire: 'WIRE',
  card: 'Card',
  preferredPaymentMethod: 'Preferred payment method',
  addBillingInfoToSetPaymentMethod:
    'Add billing info below to set it as default payment method',
  pleaseSelectBillingInfo: 'Please select a billing info',
  documents: 'Documents',
  merge: 'Merge',
  mergeCompany: 'Merge company',
  mergeCompaniesWarning: {
    caution: 'Caution!',
    allUserInformationFromTheSelected: 'All user information from the selected',
    company: 'company',
    willBe: 'will be',
    merged: 'merged'
  },
  myCompanies: 'My companies',
  myPerformers: 'My performers',
  uploadInvoices: 'Upload Invoices',
  usersInvited: 'Users invited',
  cantChangeSubcategoryMessage:
    "Can't change subcategory. To change a subcategory, all selected companies need to have the same category.",
  stateOnlyAvailableForUsaCountry:
    'State is only available for the USA. Select USA as the country or leave State empty.',
  stateOnlyForUsaCompanies:
    'State can only be updated for U.S. companies. Some selected companies are not in the USA.'
};
